import CategoryParentReferenceModelBase from '../_generated/modelBases/category-parent-reference-model-base';

export default class CategoryParentReferenceModel extends CategoryParentReferenceModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
